import React from 'react';
import clsx from 'clsx';
import { sortingOrder } from 'utils/sort';
import './styles.scss';

interface ITableHeaderCellProp {
  propName?: string;
  sortProp?: Nullable<string>;
  sortOrder?: Nullable<string>;
  children: JSX.Element;
  sortBy?: (prop: string) => void;
  theme?: Nullable<string>;
  isFromStickyTable?: boolean;
  alignCenter?: boolean;
  style?: object;
  testId?: string;
}

const TableHeaderCell = (props: ITableHeaderCellProp) => {
  const {
    propName,
    sortProp,
    sortOrder,
    sortBy,
    children,
    theme,
    isFromStickyTable = false,
    alignCenter = false,
    style,
    testId,
  } = props;

  const className = clsx(alignCenter && 'align-center', {
    'table-header': true,
    'sorted-header': sortBy && propName,
    asc: sortProp === propName && sortOrder === sortingOrder.ASC,
    desc: sortProp === propName && sortOrder === sortingOrder.DESC,
    [theme && theme === 'dark' ? 'theme-dark' : 'theme-light']: true,
  });

  let onClickSort = () => {};

  if (sortBy && propName) {
    onClickSort = () => sortBy(propName);
  }

  return isFromStickyTable ? (
    <div
      data-testid={testId ? `table-header-cell-${testId}` : 'table-header-cell'}
      onClick={onClickSort}
      styleName={className}
      style={style}
    >
      {children}
    </div>
  ) : (
    <th
      data-testid={testId ? `table-header-cell-${testId}` : 'table-header-cell'}
      onClick={onClickSort}
      styleName={className}
      style={style}
    >
      {children}
    </th>
  );
};

export default TableHeaderCell;
